import { FC, ReactNode } from "react";
import { LocationGroupType } from "@src/types.generated";
import { locationGroupTypeIcon } from "@src/features/home/constants";
import PinOutlineIcon from "@src/lib/icons/18px/pin-outline";
import IdBadge2OutlineIcon from "@src/lib/icons/18px/id-badge-2-outline";
import UsersOutlineIcon from "@src/lib/icons/18px/users-outline";
import BookmarkOutlineIcon from "@src/lib/icons/18px/bookmark-outline";

export type GroupType = "Location" | "Role" | "RoleGroup" | LocationGroupType;

type Props = {
  size: "24px";
  groupType: GroupType;
};

const GroupAvatar: FC<Props> = ({ size, groupType }) => {
  let icon: ReactNode = <BookmarkOutlineIcon className="size-5" />;
  if (groupType === "Location") {
    icon = <PinOutlineIcon className="size-4" />;
  } else if (groupType === "Role") {
    icon = <IdBadge2OutlineIcon className="size-4" />;
  } else if (groupType === "RoleGroup") {
    icon = <UsersOutlineIcon className="size-4" />;
  } else {
    icon = locationGroupTypeIcon[groupType];
  }

  return (
    <div
      className="relative overflow-hidden rounded bg-gray-4-alpha"
      style={{
        width: size,
        height: size,
      }}
    >
      <div className="absolute inset-0 z-[2] flex items-center justify-center text-gray-7 bg-gray-5-alpha">
        {icon}
      </div>
    </div>
  );
};

export default GroupAvatar;
